import { ExtGapType, PriorityLevel } from '@/common/model/media/articleCreator'

import { BadgeType } from '@/components/view/atoms/badge/Badge'
import { TextColor } from '@/components/view/atoms/text/Text'

// -----------------------------------------------
// 優先度 / 重要度（high / medium / low）
// -----------------------------------------------

export const priorityLabel = (priority: PriorityLevel | undefined): string => {
  switch (priority) {
    case 'high':
      return '高'
    case 'medium':
      return '中'
    default:
      return '低'
  }
}

export const priorityBadgeType = (priority: PriorityLevel | undefined): BadgeType => {
  switch (priority) {
    case 'high':
      return BadgeType.CRITICAL
    case 'medium':
      return BadgeType.CAUTION
    default:
      return BadgeType.SUCCESS
  }
}

export const priorityTextColor = (priority: PriorityLevel | undefined): TextColor => {
  switch (priority) {
    case 'high':
      return TextColor.CRITICAL
    case 'medium':
      return TextColor.CAUTION
    default:
      return TextColor.SECONDARY
  }
}

// 検索ボリューム（high / medium / low）
export const volumeBadgeType = (volume: PriorityLevel | undefined): BadgeType => {
  switch (volume) {
    case 'high':
      return BadgeType.EMPHASIS
    case 'medium':
      return BadgeType.DEFAULT
    default:
      return BadgeType.SECONDARY
  }
}

// -----------------------------------------------
// CVEスコア（1〜5）
// -----------------------------------------------

// ワードマップ（チャート）の塗りにも使うためHEXで保持する
export const cveColor = (cve: number | undefined): string => {
  switch (cve) {
    case 5:
      return '#E5004C'
    case 4:
      return '#FFB800'
    case 3:
      return '#EFF530'
    case 2:
      return '#E4E8EE'
    default:
      return '#94a3b8'
  }
}

export const cveLabel = (cve: number | undefined): string => {
  switch (cve) {
    case 5:
      return '購入直結'
    case 4:
      return '比較検討'
    case 3:
      return '情報収集'
    case 2:
      return '学習段階'
    case 1:
      return '潜在層'
    default:
      return ''
  }
}

// -----------------------------------------------
// 実行元（手動 / 自動）
// -----------------------------------------------

export const execSourceLabel = (source: string | null | undefined): string => {
  return source === 'scheduled' ? '自動実行' : '手動実行'
}

export const execSourceBadgeType = (source: string | null | undefined): BadgeType => {
  return source === 'scheduled' ? BadgeType.SUCCESS : BadgeType.DEFAULT
}

// -----------------------------------------------
// 拡張ギャップ分析（カニバリ / 内部リンク）
// -----------------------------------------------

export const extGapTypeLabel = (type: ExtGapType): string => {
  switch (type) {
    case ExtGapType.CANNIBALIZATION:
      return 'カニバリ分析'
    case ExtGapType.LINK_STRUCTURE:
    default:
      return '内部リンク'
  }
}

// 時系列グラフのメトリクス表示名
export const timelineMetricLabel = (key: string): string => {
  const labels: Record<string, string> = {
    total_keywords: '分析KW数',
    missing_count: '未対応',
    weak_count: '弱い',
    covered_count: 'カバー済',
    high_priority_count: '高優先',
    total_pages: 'ページ数',
    issue_count: '重複ペア',
    high_severity_count: '深刻',
    avg_overlap_score: '平均重複度',
    health_score: '健全性',
    orphan_count: '孤立',
    suggested_link_count: '推奨リンク',
    cluster_count: 'クラスター'
  }
  return labels[key] ?? key
}

// -----------------------------------------------
// AI記事生成
// -----------------------------------------------

export const TONE_CHOICES = [
  { value: 'professional', label: '専門的', description: 'データや根拠で説得力を持たせる' },
  { value: 'casual', label: 'カジュアル', description: '親しみやすく語りかけるように' },
  { value: 'friendly', label: 'フレンドリー', description: '読者の悩みに寄り添う共感型' }
] as const

// スコア（0〜100）の評価色
export const scoreTextColor = (score: number): TextColor => {
  return score >= 70 ? TextColor.SUCCESS : score >= 40 ? TextColor.CAUTION : TextColor.CRITICAL
}
